export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9038.3604276b.jpg";